module.exports = __webpack_public_path__ + "img/boomplay.48642213.png";